import axios from "axios";
import {store} from "./store";
import {Logout} from "../components/Auth/AuthActions";
import {showErrorToast} from "../utils/showToast";
import i18n from "i18next";
/*axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || "";
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);*/

axios.interceptors.response.use(
  (response) => {
    // Any status code within 2xx
    return response;
  },
  (error) => {
    // Any status codes outside 2xx
    const {status} = error.response;
    if (status === 401) {
      store.dispatch(Logout(true));
      showErrorToast(i18n.t('unauthorized'), i18n.t('unauthorized_msg'));
    } else if (status === 403) {
      showErrorToast(i18n.t('error'), i18n.t('user_not_enough_rights'));
    }
    return Promise.reject(error);
  }
);
